import { Page } from 'editor/src/store/design/types';

const isPageMediaEmpty = (page: Page) =>
  !page.groups.media?.filter((mediaElement) => !(mediaElement as any).sample).length;

export default isPageMediaEmpty;
